import { useEffect } from "react";
import { LinkGoogleAccount } from "../components/Auth/Providers/Google";
import { LinkLinkedInAccount } from "../components/Auth/Providers/LinkedIn";

/**
 * @param isAuthenticated
 */
export function usePendingSocialAccountLinking(isAuthenticated: boolean) {
  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    const pendingSocialAccountLinking = sessionStorage.getItem(
      "pendingSocialAccountLinking"
    );

    if (pendingSocialAccountLinking === "google") {
      LinkGoogleAccount();
    }

    if (pendingSocialAccountLinking === "linkedin") {
      LinkLinkedInAccount();
    }

    sessionStorage.removeItem("pendingSocialAccountLinking");
  }, [isAuthenticated]);
}
